export const GET_CONFIGURATION_PATH = '/honcho/api/configuration';

export enum ConfigKey {
  MAX_RECHARGE_AMOUNT = 'MAX_RECHARGE_AMOUNT',
  MAX_RECORD_COUNT_FOR_PDF_GENERATION = 'MAX_RECORD_COUNT_FOR_PDF_GENERATION',
  MAX_RECORD_COUNT_FOR_CSV_GENERATION = 'MAX_RECORD_COUNT_FOR_CSV_GENERATION',
}



// WEBPACK FOOTER //
// ./src/app/common/configuration.model.ts